// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';

import axios from 'axios';
Vue.prototype.axios = axios;
Vue.config.productionTip = false;

// import vant from "@vant/weapp"
// Vue.prototype.vant = vant;
// Vue.config.productionTip = false

// 引入全局样式rem
import './assets/js/remScale';
// 引入重置样式
import './assets/css/reset.css';

import swiper from 'swiper';
Vue.prototype.swiper = swiper;
Vue.config.productionTip = false;
// 引入轮播图的相关样式和交互
import 'swiper/css/swiper.min.css';
import 'swiper/js/swiper.min.js';
import './assets/js/flexible';

// title
import VueWechatTitle from 'vue-wechat-title';
Vue.use(VueWechatTitle);

import VideoPlayer from 'vue-video-player';
require('video.js/dist/video-js.css');
require('vue-video-player/src/custom-theme.css');
Vue.use(VideoPlayer);

/* eslint-disable no-new */
import Video from 'video.js';
import 'video.js/dist/video-js.css';
Vue.prototype.$video = Video;

// 引入viewui框架
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);
// 引入element ui框架
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import 'animate.css/animate.min.css';
// bootstrap
// import $ from 'jquery'
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap/dist/js/bootstrap.min.js'
Vue.use(VueWechatTitle);

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js